(function(e){if("undefined"==typeof document)return e;var t=document,n="CSS_TO_CSSJS";if(t[n]=t[n]||{},!t[n][e]){t[n][e]=!0;var r=t.createElement("style");return r.setAttribute("type","text/css"),"textContent"in r?r.textContent=e:r.styleSheet.cssText=e,t.getElementsByTagName("head")[0].appendChild(r),e}})(".signature-group{.signature-input-holder{text-align: center;font-size: 1em;color: #737373;.input {font-size: 1em;border-bottom: 1px solid #000000;line-height: 35px;color: #000000;}input.form-control {font-size: 1em;line-height: 36px;margin-bottom: 2px;}}}");


//////////////////
// WEBPACK FOOTER
// ./~/react-loose-forms.bootstrap3/inputs/Initial/index.less.js
// module id = 432
// module chunks = 0 1 2 3 4